import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pw !== pw2) { toast.error("Passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset. Please sign in.");
      nav("/login");
    } catch (e) { toast.error(apiErr(e)); } finally { setLoading(false); }
  };
  if (!token) return <div className="flex min-h-screen items-center justify-center bg-[var(--tf-bg)] text-slate-400">Invalid reset link.</div>;
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--tf-bg)] p-6">
      <div className="w-full max-w-sm tf-card p-7">
        <h1 className="font-head text-2xl font-bold text-slate-50">Reset password</h1>
        <p className="mt-1 text-sm text-slate-400">Enter your new password below.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-400">New Password</label>
            <input className="tf-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-pw" required />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-400">Confirm Password</label>
            <input className="tf-input" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-pw2" required />
          </div>
          <button data-testid="reset-submit" type="submit" disabled={loading} className="flex w-full items-center justify-center gap-2 rounded-lg bg-emerald-500 py-2.5 font-medium text-white hover:opacity-90 disabled:opacity-60">{loading ? "Resetting…" : "Reset Password"}</button>
        </form>
      </div>
    </div>
  );
}
